import { __assign } from "tslib";
/* eslint-disable no-unused-vars, no-console, camelcase */
import { uploadMediaFile } from './mediaManagerService';
import { waitForSuccessfulResponse } from './waitForSuccessfulResponse';
import { IMAGE_TYPE, VIDEO_TYPE, FILE_UPLOAD_TYPE, MediaUploadErrorKey, } from 'wix-rich-content-common';
import { getUploadError } from './mediaErrorHandler';
import { MediaType, getMediaFileType } from '@wix/ricos-common';
export var getHighestQualityVideo = function (videos) {
    var mp4 = videos.filter(function (video) { return video.format === 'mp4'; });
    var getVideoQuality = function (video) { return parseInt(video.quality, 10); };
    return mp4.reduce(function (result, video) {
        return getVideoQuality(video) > getVideoQuality(result) ? video : result;
    });
};
export var getFilePluginComponentData = function (fileName, mediaType, fileUrl) {
    return { name: fileName, type: fileName.split('.').pop() || mediaType, id: fileUrl };
};
var missingWixSessionError = { key: MediaUploadErrorKey.MISSING_WIX_SESSION };
var imageMissingWixSession = function (_, updateEntity) {
    return updateEntity({ error: missingWixSessionError });
};
var fileMissingWixSession = function (file, updateEntity) {
    return updateEntity({
        data: { name: file.name, type: getMediaFileType(file.name) },
        error: missingWixSessionError,
    });
};
var videoMissingWixSession = function (_, updateEntity) {
    return updateEntity({ error: missingWixSessionError });
};
var uploadFile;
export default function uploadStrategy(metaSiteId, userId, siteOwnerId, hasPlugin) {
    var _a, _b;
    if (!metaSiteId)
        return {};
    if (!uploadFile && userId)
        uploadFile = uploadMediaFile(metaSiteId, userId);
    var handleUploadError = function (error, updateEntity) {
        var isOwner = siteOwnerId === userId;
        var mediaUploadError = getUploadError(error, metaSiteId, isOwner);
        updateEntity({ error: mediaUploadError });
    };
    var imageUpload = function (file, updateEntity) {
        return uploadFile(file, MediaType.IMAGE)
            .then(function (_a) {
            var file_name = _a.file_name, original_file_name = _a.original_file_name, height = _a.height, width = _a.width;
            updateEntity({
                data: {
                    id: file_name,
                    height: height,
                    width: width,
                    original_file_name: original_file_name,
                    file_name: file_name,
                },
            });
        })
            .catch(function (error) { return handleUploadError(error, updateEntity); });
    };
    var videoUpload = function (file, updateEntity) {
        return uploadFile(file, MediaType.VIDEO)
            .then(function (_a) {
            var _b = _a.file_output, video = _b.video, image = _b.image;
            return waitForSuccessfulResponse("https://video.wixstatic.com/" + getHighestQualityVideo(video).url).then(function () {
                updateEntity({
                    data: {
                        pathname: getHighestQualityVideo(video).url,
                        thumbnail: {
                            pathname: image[0].url,
                            width: image[0].width,
                            height: image[0].height,
                        },
                    },
                });
            });
        })
            .catch(function (error) { return handleUploadError(error, updateEntity); });
    };
    var getUnsupportedExtensionError = function (fileName) {
        var _a;
        return {
            key: MediaUploadErrorKey.UNSUPPORTED_EXTENSION,
            args: { extension: ((_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '' },
        };
    };
    var galleryUpload = function (file, updateEntity) {
        var fileType = getMediaFileType(file.name);
        if (fileType === MediaType.IMAGE) {
            return imageUpload(file, updateEntity);
        }
        else if (fileType === MediaType.VIDEO) {
            return videoUpload(file, updateEntity);
        }
        else {
            return updateEntity({
                error: getUnsupportedExtensionError(file.name),
            });
        }
    };
    var fileUpload = function (file, updateEntity) {
        var fileType = getMediaFileType(file.name);
        return uploadFile(file, fileType)
            .then(function (_a) {
            var name = _a.original_file_name, media_type = _a.media_type, file_url = _a.file_url, file_output = _a.file_output;
            var fileUrl = (file_output === null || file_output === void 0 ? void 0 : file_output.video) ? getHighestQualityVideo(file_output.video).url
                : file_url;
            var componentData = getFilePluginComponentData(name, media_type, fileUrl);
            updateEntity({ data: componentData });
        })
            .catch(function (error) { return handleUploadError(error, updateEntity); });
    };
    var uploadFunctions = (_a = {},
        _a[IMAGE_TYPE] = userId ? galleryUpload : imageMissingWixSession,
        _a[VIDEO_TYPE] = userId ? videoUpload : videoMissingWixSession,
        _a[FILE_UPLOAD_TYPE] = userId ? fileUpload : fileMissingWixSession,
        _a);
    return {
        helpers: __assign({}, (hasPlugin(IMAGE_TYPE) && { handleFileUpload: uploadFunctions[IMAGE_TYPE] })),
        config: (_b = {},
            _b[VIDEO_TYPE] = __assign({}, (hasPlugin(VIDEO_TYPE) && {
                handleFileUpload: uploadFunctions[VIDEO_TYPE],
                enableCustomUploadOnMobile: true,
            })),
            _b[FILE_UPLOAD_TYPE] = __assign({}, (hasPlugin(FILE_UPLOAD_TYPE) && {
                onFileSelected: uploadFunctions[FILE_UPLOAD_TYPE],
                accept: '*',
            })),
            _b),
    };
}
//# sourceMappingURL=uploadStrategy.js.map